module.exports = __webpack_public_path__ + "img/success_icon.adbf70b9.png";